import { CommunicationStatusRow } from "@/hooks/useCommunicationStatus";
import { Circle } from "lucide-react";

interface Props {
  row?: CommunicationStatusRow | null;
  labelPending?: string;
  labelSent?: string;
  compact?: boolean;
}

/**
 * Reusable red/green communication badge.
 * Works with any entity via useCommunicationStatusList().
 */
const CommunicationStatusBadge = ({
  row,
  labelPending = "Confirmation email not sent yet",
  labelSent = "Confirmation email sent",
  compact = false,
}: Props) => {
  const sent = row?.status === "sent";
  const cls = sent
    ? "bg-green-100 text-green-800 border-green-300"
    : "bg-red-100 text-red-800 border-red-300";
  const label = sent ? labelSent : labelPending;
  return (
    <span
      className={`inline-flex items-center gap-1 border px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}
      title={
        sent && row?.sent_at
          ? `Sent ${new Date(row.sent_at).toLocaleString()}${
              row.sent_by_name ? ` by ${row.sent_by_name}` : ""
            }`
          : label
      }
    >
      <Circle className={`h-2 w-2 fill-current ${sent ? "text-green-600" : "text-red-600"}`} />
      {compact ? (sent ? "Sent" : "Not sent") : label}
    </span>
  );
};


export default CommunicationStatusBadge;
